const __PROD__ = process.env.NODE_ENV === 'production';

// configure sanitiser (undefined in production)
export default window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__({
  // do not log large sample payloads for graphs
  actionSanitizer: action => (
    action.type === 'devices/RECEIVE_DEVICE_SAMPLES' && action.response
      ? {
        ...action,
        response: {
          ...action.response,
          _embedded: `<<${action.response.count} SAMPLES>>`,
        },
      }
      : action
  ),
  // a stateSanitizer can go here
  // Sanitize redux state and action on prod. But it's still required on dev as a way to debug.
  stateSanitizer: state => (__PROD__ ? {app: state.app || {}, _persist: state._persist || {}} : state),
  actionsAllowlist: __PROD__ ? ['app/APP_LOAD'] : [],
  serialize: true,
});
